export default {
  OK: "អូខេ",
  CLOSE: "គណនីត្រូវបានបិទ!",
  BLOCK: "គណនីត្រូវបានបាំង!",
  FREEZE: "គណនីត្រូវបានបង្កក!",
  SUSPEND: "គណនីរបស់អ្នកត្រូវបានផ្លាស់ប្តូរទៅមើលបានតែប៉ុណ្ណោះ។",
  passwordRequired: "ត្រូវការលេខសម្ងាត់!",
  usernameRequired: "ត្រូវការឈ្មោះអ្នកប្រើប្រាស់!",
  incompletedRequest: "មានអ្វីមួយខុស...",

  session_not_exists: "វគ្គបានផុតកំណត់! សូមចូលឡើងវិញដើម្បីបន្ត...",
  session_expired: "វគ្គបានផុតកំណត់! សូមចូលឡើងវិញដើម្បីបន្ត...",
  invalidSession: "វគ្គបានផុតកំណត់! សូមចូលឡើងវិញដើម្បីបន្ត...",
  accountIdRequired: "វគ្គបានផុតកំណត់! សូមចូលឡើងវិញដើម្បីបន្ត...",
  NoUserAccessRight: "មិនអនុញ្ញាត! សូមទាក់ទងអ្នកណែនាំរបស់អ្នកដើម្បីបន្ត...",
  account_not_exists: "លេខសម្ងាត់មិនត្រឹមត្រូវ។",
  invalid_password: "លេខសម្ងាត់មិនត្រឹមត្រូវ។",
  secondary_account_exists: "អ្នកបានបង្កើតសម្មតិនាមរួចហើយ។",
  systemError: "បញ្ហាក្នុងប្រព័ន្ធផ្ទៃក្នុង។",
  new_login_id_exists: "សម្មតិនាមមិនត្រឹមត្រូវ សូមសាកល្បងដាក់ឈ្មោះផ្សេងទៀត។",
  loginLimit: "អ្នកបានចូលប្រើញឹកញាប់ពេក សូមសាកល្បងម្ដងទៀតបន្ទាប់ពី 1 នាទី...",
  requestLimit: "អ្នកបានស្នើរញឹកញាប់ពេក។",
  unableToGetBalanceAtTheMoment: "បញ្ហាជាមួយម៉ាស៊ីនមេ។",
  oddsDisplayInvalid: "អត្រាកំពុងធ្វើបច្ចុប្បន្នភាព...",
  oddsIsUpdating: "អត្រាកំពុងធ្វើបច្ចុប្បន្នភាព...",
  atLeastTwoMatchToBetParlay: "ត្រូវការផ្សំពីយ៉ាងតិចពីរប្រកួតសម្រាប់ភ្នាល់បែប parlay។",
  atLeastThreeMatchToBetParlay: "ត្រូវការផ្សំពីយ៉ាងតិចបីប្រកួតសម្រាប់ភ្នាល់បែប parlay។",
  duplicate_debit_record: "អត្រាកំពុងធ្វើបច្ចុប្បន្នភាព...",

  insufficient_balance: "ប្រាក់មិនគ្រប់គ្រាន់",
  betOverMaxPerMatch: "ប្រាក់ភ្នាល់លើសចំនួនអតិបរមា។",
  betOverMax: "ប្រាក់ភ្នាល់លើសចំនួនអតិបរមា។",
  betOverMaxBet: "ប្រាក់ភ្នាល់លើសចំនួនអតិបរមា។",
  betLowerMin: "ប្រាក់ភ្នាល់ទាបជាងចំនួនអប្បបរមា។",

  loginFailed: "ការចូលបរាជ័យ សូមសាកល្បងម្ដងទៀតនៅពេលក្រោយ...",
  requestFailed: "ការភ្ជាប់របស់អ្នកមិនមានស្ថេរភាព។ សូមពិនិត្យការភ្ជាប់របស់អ្នកហើយសាកល្បងម្ដងទៀត។",
  requestPending: "សំណើរនៅរងចាំ...",

  close: "គណនីត្រូវបានបិទ! សូមទាក់ទងអ្នកណែនាំរបស់អ្នកដើម្បីបន្ត...",
  suspend: "គណនីត្រូវបានផ្អាក! សូមទាក់ទងអ្នកណែនាំរបស់អ្នកដើម្បីបន្ត...",
  freeze: "គណនីត្រូវបានបង្កក! សូមទាក់ទងអ្នកណែនាំរបស់អ្នកដើម្បីបន្ត...",

  alphaNumOnly: "អក្សរភាសាឡាតាំង និងលេខប៉ុណ្ណោះ",

  // vuelidate
  isRequired: "សូមបញ្ចូល {fname}។",
  isMinValue: "{fname} ត្រូវតែមានតិចបំផុតជា {fvalue}។",
  isMaxValue: "{fname} ត្រូវតែតិចជាង ឬ ស្មើនឹង {fvalue}។",
  isMinLength: "{fname} ត្រូវមានអក្សរយ៉ាងតិច {fvalue} តួ។",
  isMaxLength: "{fname} ត្រូវមានអក្សរតិចជាង ឬ ស្មើនឹង {fvalue} តួ។",
  isAlpha: "{fname} អាចបញ្ចូលបានតែអក្សរប៉ុណ្ណោះ។",
  isAlphaNum: "{fname} អាចបញ្ចូលបានតែអក្សរនិងលេខ។",
  isNumeric: "{fname} អាចបញ្ចូលបានតែលេខប៉ុណ្ណោះ។",
  isEmail: "{fname} ត្រូវតែជាស្ថាប័នអ៊ីមែលត្រឹមត្រូវ។",
  isIpAddress: "{fname} ត្រូវតែជាអាសយដ្ឋាន IPv4 ត្រឹមត្រូវ។",
  isSameAs: "{fname} ត្រូវតែដូចនឹង {fname2}។",
  isUrl: "{fname} ត្រូវតែជាអាសយដ្ឋាន URL ត្រឹមត្រូវ។",
  containAlphaNum: "{fname} ត្រូវមានអក្សរនិងលេខយ៉ាងហោចណាស់មួយ។",
  selectOption: "សូមជ្រើសរើស {fname}",
  notSameAs: "{fname} និង {fname2} មិនអាចដូចគ្នាបានទេ។",

  currPasswordRequired: "ត្រូវការលេខសម្ងាត់បច្ចុប្បន្ន!",
  newPasswordRequired: "ត្រូវការលេខសម្ងាត់ថ្មី!",
  confirmNewPasswordRequired: "ត្រូវការបញ្ជាក់លេខសម្ងាត់ថ្មី!",
  passwordsNotMatch: "លេខសម្ងាត់មិនដូចគ្នាទេ!",
  nickNameRequired: "ត្រូវការសម្មតិនាម!",

  startDateRequired: "ត្រូវការកាលបរិច្ឆេទចាប់ផ្តើម!",
  endDateRequired: "ត្រូវការកាលបរិច្ឆេទបញ្ចប់!",
  pageSizeRequired: "ត្រូវការទំហំទំព័រ!",
  pageNumberRequired: "ត្រូវការលេខទំព័រ!",
  sportsTypeRequired: "ត្រូវការប្រភេទកីឡា!",

  workingDateRequired: "ត្រូវការកាលបរិច្ឆេទធ្វើការ!",
  leagueIdRequired: "ត្រូវការលេខសម្គាល់លីគ!",
  isOutrightRequired: "ត្រូវការការជ្រើសរើសទាំងមូល!",

  maxParlayTicket: "ឈានដល់ចំនួនសំបុត្រអតិបរមាសម្រាប់ភ្នាល់បញ្ចូលច្រើនប្រកួតរួចហើយ!",
  matchHide: "ទីផ្សារនេះមិនមានទេ សូមសាកល្បងទីផ្សារផ្សេងទៀត។",
  matchNotAllowBet: "ទីផ្សារនេះមិនមានទេ សូមសាកល្បងទីផ្សារផ្សេងទៀត។",
  matchNotActive: "ការប្រកួតនេះមិនអាចភ្នាល់បានទេ សូមសាកល្បងទីផ្សារប្រកួតផ្សេងទៀត។",
  invalidBets: "ទីផ្សារនេះមិនមានទេ សូមសាកល្បងទីផ្សារផ្សេងទៀត។",

  invalidOddsBall: "កំពុងធ្វើបច្ចុប្បន្នភាពអ៊ុត...",
  selectLeague: "សូមជ្រើសយ៉ាងហោចណាស់ 1 លីគ",
  liveCasinoDisabled: "លៃវ៉ាកាស៊ីណូបានបិទ",
  lotteryDisabled: "សំបុត្រឆ្នោតបានបិទ",
  slotDisabled: "ម៉ាស៊ីនស្លុតបានបិទ",
  MiniGameDisabled: "ហ្គេមតូចៗបានបិទ",
  EsportsDisabled: "ហ្គេម E-Sports បានបិទ",
  betTypeRequired: "ត្រូវការប្រភេទភ្នាល់។",
  betAmountRequired: "ត្រូវការចំនួនទឹកប្រាក់ភ្នាល់។",
  invalidBetAmount: "ចំនួនទឹកប្រាក់ភ្នាល់មិនត្រឹមត្រូវ។",
  currencyNotSupported: "រូបិយប័ណ្ណនេះមិនត្រូវបានគាំទ្រ។",
  game_maintenance: "ហ្គេមកំពុងថែទាំប្រព័ន្ធ។",
  forbiddenAccess: "ការចូលប្រើត្រូវបានហាមឃាត់",
  invalidCurrency: "រូបិយប័ណ្ណមិនត្រឹមត្រូវសម្រាប់ភ្នាល់។",
  connectionFailed: "បរាជ័យក្នុងការភ្ជាប់ប្រព័ន្ធកាបូប។",


  //tournament
  login_id_not_exists: "ការចូលមិនត្រឹមត្រូវ សូមព្យាយាមចូលឡើងវិញ។",
  noMatchSelected: "សូមជ្រើសយ៉ាងហោចណាស់ 1 ប្រកួត។",
  invalidRoomRate: "អត្រាបន្ទប់មិនត្រឹមត្រូវ។",
  invalidRoomLimit: "ការកំណត់ចំនួនអ្នកលេងមិនត្រឹមត្រូវ។",
  invalidRoomPassword: "PIN មិនត្រឹមត្រូវ។ PIN ត្រូវតែមាន 6 ខ្ទង់ជាលេខ។",
  invalidPassword: "ពាក្យសម្ងាត់មិនត្រឹមត្រូវ",
  roomPasswordRequired: "ត្រូវការបញ្ចូល PIN។",
  minMatch: "ត្រូវជ្រើសយ៉ាងហោចណាស់ 3 ប្រកួត។",
  maxMatch: "អតិបរមា {max} ប្រកួត!",
  roomIdRequired: "ត្រូវការបញ្ចូលលេខសម្គាល់បន្ទប់។",
  roomTypeRequired: "ត្រូវការបញ្ជាក់ប្រភេទបន្ទប់។",
  sessionTokenRequired: "ត្រូវការកូដសម័យប្រើប្រាស់។",
  matchDateRequired: "ត្រូវការថ្ងៃការប្រកួត។",
  matchRequired: "ត្រូវការជ្រើសប្រកួត។",
  roomLimitRequired: "ត្រូវការកំណត់ចំនួនអ្នកលេង។",
  roomRateRequired: "ត្រូវការកំណត់អត្រាបន្ទប់។",
  minRoomRate: "ថ្លៃចូលរួមត្រូវមាន 10 ឬច្រើនជាងនេះ។",
  maxRoomRate: "ថ្លៃចូលរួមត្រូវមាន 1000 ឬតិចជាងនេះ។",
  minRoomLimit: "ចំនួនអ្នកលេងត្រូវមាន 3 ឬច្រើនជាងនេះ។",
  maxRoomLimit: "ចំនួនអ្នកលេងត្រូវមាន 30 ឬតិចជាងនេះ។",
  invalidRoomType: "ប្រភេទបន្ទប់មិនត្រឹមត្រូវ។",
  invalidMatch: "ការប្រកួតមិនត្រឹមត្រូវ។",
  dataError: "បញ្ហាទិន្នន័យ",
  MemberExists: "សមាជិកមានរួចហើយ។",
  invalidMember: "សមាជិកមិនត្រឹមត្រូវ។",
  invalidleague: "លីគមិនត្រឹមត្រូវ។",
  "createRoomFailed-1": "បរាជ័យក្នុងការបង្កើតបន្ទប់ 1។",
  "createRoomFailed-2": "បរាជ័យក្នុងការបង្កើតបន្ទប់ 2។",
  "createRoomFailed-3": "បរាជ័យក្នុងការបង្កើតបន្ទប់ 3។",
  invalidOperator: "ប្រតិបត្តិករមិនត្រឹមត្រូវ។",
  roomFull: "បន្ទប់ពេញរួចហើយ។",
  memberExists: "សមាជិកមានរួចហើយ។",
  "joinFailed-1": "បរាជ័យក្នុងការចូលបន្ទប់ 1។",
  "joinFailed-2": "បរាជ័យក្នុងការចូលបន្ទប់ 2។",
  IPJoinedBefore: "IP នេះបានចូលរួចមកហើយ។",
  memberJoinedBefore: "អ្នកបានចូលរួចមកហើយ សូមចងចាំថាបន្ទប់សាធារណៈឥតគិតថ្លៃអាចចូលបានតែម្ដងប៉ុណ្ណោះ។",
  roomNotExists: "បន្ទប់មិនមានទេ។",
  roomIsPublicFree: "បន្ទប់នេះជាបន្ទប់សាធារណៈឥតគិតថ្លៃ។",
  roomEndedOrCancelled: "បន្ទប់បានបញ្ចប់ឬបានលុបចោល។",
  roomEnded: "បន្ទប់បានបញ្ចប់រួចហើយ។",


  matchLowerMin: "កំហុស៖ ចំនួនប្រកួតតិចជាងអប្បបរមា។",
  matchOverMax: "កំហុស៖ ចំនួនប្រកួតលើសអតិបរមា។",
  pointsOverLimit: "កំហុស៖ ពិន្ទុលើសកំណត់។",
  roomOverMax: "កំហុស៖ បន្ទប់លើសចំនួនអតិបរមា។",
  invalidRoom: "បន្ទប់មិនត្រឹមត្រូវ។",
  roomLimitOverMax: "កំហុស៖ កំណត់ចំនួនអ្នកលេងលើសអតិបរមា។",
  rateLowerMin: "កំហុស៖ អត្រាតិចជាងអប្បបរមា។",
  rateOverMax: "កំហុស៖ អត្រាលើសអតិបរមា។",

  liveMatchNotAllowed: "មិនអនុញ្ញាតឲ្យប្រកួតបន្តផ្ទាល់។",
  roomLimitLowerMin: "កំហុស៖ កំណត់ចំនួនអ្នកលេងតិចជាងអប្បបរមា។",
  roomClosed: "បន្ទប់បានបិទ។",
  tournamentLeagueExists: "លីគក្នុងវគ្គប្រកួតមានរួចហើយ។",
  roomExists: "មិនអាចបង្កើតបន្ទប់ឯកជនច្រើនជាង 1 បានទេ។",
  RoomExists: "មិនអាចបង្កើតបន្ទប់ឯកជនច្រើនជាង 1 បានទេ។",
  betExists: "ការភ្នាល់មានរួចហើយ។",
  roomClosedNotAllowed: "មិនអាចចូលបន្ទប់ដែលបិទ។",
  tournamentMatchExists: "ការប្រកួតក្នុងវគ្គប្រកួតមានរួចហើយ។",
  account_id_required: "ត្រូវការលេខសម្គាល់គណនី។",
  agent_comm_rate_required: "ត្រូវការអត្រាគម្រោងជាន់អាជេន។",
  agent_id_required: "ត្រូវការលេខសម្គាល់អាជេន។",
  bet_amount_required: "ត្រូវការទំហំភ្នាល់។",
  bet_id_required: "ត្រូវការលេខសម្គាល់ការភ្នាល់។",
  credit_amount_required: "ត្រូវការចំនួនបញ្ចូលប្រាក់។",
  currency_required: "ត្រូវការជ្រើសរូបិយប័ណ្ណ។",
  debit_amount_required: "ត្រូវការចំនួនដកប្រាក់។",
  duplicate_credit_record: "កំណត់ត្រាបញ្ចូលប្រាក់ស្ទួន។",
  master_comm_rate_required: "ត្រូវការអត្រាគម្រោងជាន់មេ។",
  master_id_required: "ត្រូវការលេខសម្គាល់ជាន់មេ។",
  member_id_required: "ត្រូវការលេខសម្គាល់សមាជិក។",
  member_wallet_not_exists: "កាបូបសមាជិកមិនមានទេ។",
  permission_denied: "មិនមានសិទ្ធិចូលប្រើ។",
  rate_required: "ត្រូវការអត្រា។",
  result_exists: "លទ្ធផលមានរួចហើយ។",
  room_id_required: "ត្រូវការលេខសម្គាល់បន្ទប់។",
  s_senior_comm_rate_required: "ត្រូវការអត្រាគម្រោង Super Senior។",
  s_senior_id_required: "ត្រូវការលេខសម្គាល់ Super Senior។",
  senior_comm_rate_required: "ត្រូវការអត្រាគម្រោង Senior។",
  senior_id_required: "ត្រូវការលេខសម្គាល់ Senior។",
  shareholder_comm_rate_required: "ត្រូវការអត្រាគម្រោងម្ចាស់ភាគហ៊ុន។",
  shareholder_id_required: "ត្រូវការលេខសម្គាល់ម្ចាស់ភាគហ៊ុន។",
  transfer_id_required: "ត្រូវការលេខសម្គាល់ការផ្ទេរ។",
  minBetAmount: "កំហុស៖ ចំនួនភ្នាល់អប្បបរមា។",
  tournamentDisabled: "វគ្គប្រកួតត្រូវបានបិទ សូមទាក់ទងអ្នកណែនាំរបស់អ្នក។",
  marketTypeRequired: "ត្រូវការបញ្ជាក់ប្រភេទទីផ្សារ។",
  invalidMarketType: "ប្រភេទទីផ្សារមិនត្រឹមត្រូវ។",
  marketTypeChanged: "សន្លឹកភ្នាល់ត្រូវបានលុបចេញដោយសារប្រភេទទីផ្សារបានផ្លាស់ប្តូរ។<br />សូមជ្រើសវិញពីទីផ្សារថ្មី។",
  changeStakeMin: "ចំនួនភ្នាល់ត្រូវបានកែប្រែដោយសារខុសអប្បបរមា។",
  changeStakeMax: "ចំនួនភ្នាល់ត្រូវបានកែប្រែដោយសារលើសអតិបរមា។",
  betNotExists: "សូមដាក់ភ្នាល់ដែលត្រឹមត្រូវដើម្បីចូលរួមវគ្គប្រកួត។",
  cashOutUnavailable: "ការផ្ទេរមិនអាចប្រើបានទេ។",
  errorCashoutAmount: "ការផ្ទេរកំពុងធ្វើបច្ចុប្បន្នភាព...",
  freeRoomNeedBet: "សូមដាក់ភ្នាល់ដែលត្រឹមត្រូវដើម្បីចូលរួមវគ្គប្រកួត។",

  startTimeRequired: "តម្រូវឲ្យមានពេលវេលាចាប់ផ្តើម។",
  endTimeRequired: "តម្រូវឲ្យមានពេលវេលាបញ្ចប់។",
  oddsTypeIDRequired: "តម្រូវឲ្យមានប្រភេទហាងឆេង។",
  commissionRequired: "តម្រូវឲ្យមានកម្រៃជើងសារ។",
  requestTimeRequired: "តម្រូវឲ្យមានពេលវេលាស្នើសុំ។",
  statusRequired: "តម្រូវឲ្យមានស្ថានភាព។",
  invalidStartTime: "ពេលវេលាចាប់ផ្តើមមិនត្រឹមត្រូវ។",
  invalidEndTime: "ពេលវេលាបញ្ចប់មិនត្រឹមត្រូវ។",
  invalidOddsTypeID: "ប្រភេទហាងឆេងមិនត្រឹមត្រូវ។",
  invalidCommission: "កម្រៃជើងសារមិនត្រឹមត្រូវ។",
  invalidRequestTime: "ពេលវេលាស្នើសុំមិនត្រឹមត្រូវ។",
  invalidStatus: "ស្ថានភាពមិនត្រឹមត្រូវ",
  invalidAlgoMatchInfo: "ទីផ្សារនេះត្រូវបានបិទហើយ សូមសាកល្បងទីផ្សារផ្សេងទៀត។ (-101)",
  invalidAlgoSliderLeagueInfo: "ព័ត៌មានលីគមិនត្រឹមត្រូវ។",
  invalidAlgoSliderMinutesWeight: "ទម្ងន់នាទីមិនត្រឹមត្រូវ។",
  invalidAlgoSliderBetType: "ការភ្នាល់មិនត្រឹមត្រូវ ប្រភេទ។",
  invalidRTSRunningScoreDetails: "ព័ត៌មានលម្អិតអំពីពិន្ទុរត់ (RTS) មិនត្រឹមត្រូវ។",
  invalidProviderGoalTimeLine: "បន្ទាត់ពេលវេលាគោលដៅរបស់អ្នកផ្តល់សេវាមិនត្រឹមត្រូវ។",
  invalidSliderTimeRange: "ជួរពេលវេលាមិនត្រឹមត្រូវ។",
  invalidMOMatchOdds: "ហាងឆេងការប្រកួតកំពុងធ្វើបច្ចុប្បន្នភាព...",
  invalidProviderSlider: "ព័ត៌មាន TM មិនត្រឹមត្រូវ។",
  invalidCombineBetTypeAndOddsFormat: "ប្រភេទភ្នាល់ និងទម្រង់ហាងឆេងរួមបញ្ចូលគ្នាមិនត្រឹមត្រូវ។",
  invalidMatchInformation: "ព័ត៌មានការប្រកួតមិនត្រឹមត្រូវ។",
  marketClose: "ទីផ្សារនេះត្រូវបានបិទហើយ សូមសាកល្បងទីផ្សារផ្សេងទៀត។",
  error: "កំហុស"
};


// export default {
//   OK: "OK",
//   CLOSE: "Account has been closed!",
//   passwordRequired: "Password is required!",
//   usernameRequired: "Username is required!",

//   session_not_exists: "Session expired! Please login again to continue...",
//   session_expired: "Session expired! Please login again to continue...",
//   invalidSession: "Session expired! Please login again to continue...",
//   accountIdRequired: "Session expired! Please login again to continue...",
//   NoUserAccessRight: "Permission denied! Please contact your upline to continue...",
//   account_not_exists: "Invalid password.",
//   invalid_password: "Invalid password.",
//   secondary_account_exists: "Your nickname already created.",
//   systemError: "Internal System Error.",
//   new_login_id_exists: "Invalid nickname, please try to set different nickname.",
//   loginLimit: "You have login too frequent, please try again after 1 minute...",
//   requestLimit: "You have request too frequent.",
//   unableToGetBalanceAtTheMoment: "Internal Server Error.",
//   oddsDisplayInvalid: "Invalid Odds Display.",
//   oddsIsUpdating: "Odds Is Updating...",
//   atLeastTwoMatchToBetParlay: "At least mix two match to bet in parlay.",

//   insufficient_balance: "Insufficient Balance",
//   betOverMaxPerMatch: "Your stake exceeds the max stake.",
//   betOverMax: "Your stake exceeds the max stake.",
//   betLowerMin: "Your stake less than the min stake.",


//   loginFailed: "Login failed, please try again later...",
//   requestFailed: "Request failed, please check your internet connection.",

//   close: "Account is closed! Please contact your upline to continue...",
//   suspend: "Account is suspend! Please contact your upline to continue...",
//   freeze: "Account is freeze! Please contact your upline to continue...",

//   alphaNumOnly: "Alphanumeric only",

//   // vuelidate
//   isRequired: "Please enter a {fname}.",
//   isMinValue: "{fname} must have minimal of {fvalue}.",
//   isMaxValue: "{fname} must be less than or equal to {fvalue}.",
//   isMinLength: "{fname} must have at least {fvalue} characters.",
//   isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
//   isAlpha: "{fname} accept only alphabet.",
//   isAlphaNum: "{fname} accept only alphanumerics.",
//   isNumeric: "{fname} accept only numerics.",
//   isEmail: "{fname} accept only valid email addresses.",
//   isIpAddress: "{fname} accept only valid IPv4 addresses.",
//   isSameAs: "{fname} must be same as {fname2}.",
//   isUrl: "{fname} accept only URLs.",
//   containAlphaNum: "{fname} must have at least one alphabet and one number.",
//   selectOption: "Please select a {fname}",
//   notSameAs: "{fname} and {fname2} cannot be the same.",

//   currPasswordRequired: "Current password is required!",
//   newPasswordRequired: "New password is required!",
//   confirmNewPasswordRequired: "Confirm new password is required!",
//   passwordsNotMatch: "Passwords do not match!",
//   nickNameRequired: "Nickname is required!",

//   startDateRequired: "Start date is required!",
//   endDateRequired: "End date is required!",
//   pageSizeRequired: "Page size is required!",
//   pageNumberRequired: "Page number is required!",
//   sportsTypeRequired: "Sports type is required!",

//   workingDateRequired: "Working date is required!",
//   leagueIdRequired: "League ID is required!",
//   isOutrightRequired: "Is outright is required!"

// };
